<template>
	<div>
		<h3>Customer & Contract</h3>

		<form-group label="Customer" col-class="col-sm-3 col-lg-2">

			<div class="d-flex flex-wrap">
				<field style="flex-grow: 1;margin-right: 10px;"
					v-model="$store.service.customer_id" 
					:params="{type: 'select', options: $store.customerOptions}" 
					:readonly="readonly" 
					:invalid="$store.errorList.customer_id"
					v-on:change="customerSelected">
				</field>

				<div>
					<button v-if="!readonly && hasModulePermWrite('Contacts')" class="btn btn-light float-right" type="button" v-on:click="newCustomerModalVisible = true">
						<i class="fa fa-plus"></i>
						New Customer
					</button>
				</div>
			</div>

			<alert :visible="overdueInvoiceAlertVisible"
				icon="fa-exclamation-triangle"
				classes="alert-warning"
				v-on:close="overdueInvoiceAlertVisible = false">

				This customer has {{overdueInvoices.length}} overdue invoices:

				<ul style="margin-bottom: 0">
					<li v-for="invoice in overdueInvoices">
						
						<router-link v-if="invoice.Service" :to="'/service/'+invoice.Service.slug+'/invoice'">#{{ invoice.Service.job_num }}</router-link>
						<router-link v-else :to="'/invoice/' + invoice.slug + '/details'">#{{ invoice.standalone_num }}</router-link>

						due {{formatDate(invoice.due_date)}} ({{moment().diff(moment(invoice.due_date),'days')}} days overdue)
					</li>
				</ul>

			</alert>

			<alert v-if="selectedCustomer && selectedCustomer.customer_onhold == 1"
				:visible="true"
				icon="fa-exclamation-triangle"
				classes="alert-warning pb-0"
				:unclosable="true">

				This customer has been placed on hold:

				<p><strong>Reason:</strong> {{selectedCustomer.customer_onhold_reason ? selectedCustomer.customer_onhold_reason : '[none specified]'}}</p>


			</alert>

		</form-group>

		<field 
			v-if="(customerServiceContractOptions.length > 0 || $store.service.contract_id > 0) && !isQuote"
			label="Service Contract" 
			col-class="col-md-3 col-lg-2" 
			v-model="$store.service.contract_id" 
			v-on:change="contractSelected"
			:params="{type:'select',options:customerServiceContractOptions}">
		</field>

		<field v-if="!isQuote"
			label="Customer PO #" 
			col-class="col-md-3 col-lg-2" 
			v-model="$store.service.customer_po" 
			:readonly="readonly" 
			:invalid="$store.errorList.customer_po">
		</field>

		<new-contact-modal
			:visible="newCustomerModalVisible"
			:is-customer="true"
			v-on:contactAdded="customerAdded"
			v-on:closeModal="newCustomerModalVisible = false">
		</new-contact-modal>
	</div>
</template>
<script type="text/javascript">
import ServiceMixins from "@/mixins/ServiceMixins.js"

import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"
import Alert from "@/components/Alert"

import NewContactModal from "@/components/super_components/NewContactModal"

export default {
	name: "CustomerSection",
	components: {
		FormGroup,
		Field,
		Alert,
		NewContactModal
	},
	mixins: [ServiceMixins],
	props: ["customerServiceContractOptions","readonly","isNewEmergency"],
	data() {
		return {
			overdueInvoices: [],
			overdueInvoiceAlertVisible: false,
			newCustomerModalVisible: false,
			selectedCustomer: null
		}
	},
	watch: {
		'$store.service.id'() {
			this.fetchCustomerContracts()
		}
	},
	methods: {
		contractSelected(value) {
			this.$emit("contractSelected",value)
		},
		customerAdded(response) {
			let vm = this
			this.newCustomerModalVisible = false
			this.fetchCustomers().then(customerResponse => {
				vm.$store.service.customer_id = response.data.record_id
				vm.$forceUpdate()
			})
		},
		customerSelected(customer_id) {
			let vm = this

			this.overdueInvoiceAlertVisible = false
			this.selectedCustomer = null

			this.$store.service.contract_id = null

			this.$nextTick(() => {

				this.$emit("customerSelected",vm.$store.service.customer_id)

				let invoiceFilters = [
					['is_paid',0],
					['due_date <',this.moment().format("YYYY-MM-DD")],
					['customer_id',vm.$store.service.customer_id],
					['issue_date !=', null],
					['finalized',1],
					['is_quote',0]
				]

				let promises = [
					vm.fetchCustomerContracts(),
					vm.getJSON("ServiceInvoice/get",{
						fields: ["id","due_date","is_paid","customer_id","amount_paid","grand_total","is_freeform","standalone_num"],
						filters: invoiceFilters,
						include:[
							{model:"Service",fields:["id","job_num","customer_id"]
						}]
					}),
				]

				Promise.all(promises).then(responses => {

					vm.overdueInvoices = responses[1].data
					if (vm.overdueInvoices.length > 0)
						vm.overdueInvoiceAlertVisible = true
					else
						vm.overdueInvoiceAlertVisible = false

					
				})

				vm.getJSON("Contact/find/"+customer_id,{fields: ["id","name","customer_onhold","customer_onhold_reason"]}).then(response => {
					if (response.success)
						vm.selectedCustomer = response.data
				})

			})
		}
	}
} 

</script>